import {StoragePromoCodeRepository} from '@domain/model/PromoCode/StoragePromoCodeRepository';

const GetPromoBannerFlag = (repository: StoragePromoCodeRepository) => (): boolean => {
  return repository.getPromoBannerFlag();
};

export {GetPromoBannerFlag};
